import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

export function useAdminClient() {
  const navigate = useNavigate();
  
  const client = useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_API_HOST,
      headers: {
        "Content-Type": "application/json"
      }
    });
    
    instance.interceptors.request.use((config) => {
      config.headers.Authorization = `Bearer ${localStorage.getItem("authToken")}`;
      return config;
    });

    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 403) {
          localStorage.removeItem("authToken");
          navigate("/admin");
          return error?.response;
        }
        return Promise.reject(error);
      }
    );
    
    return instance;
  }, []);
  
  return client;
}